export default __webpack_public_path__ + "static/5-03dbbe3d5730f534e48acd2bfea3499f.png";